export function monthDiff(
  dateFrom: { getMonth: () => number; getFullYear: () => number } | null,
  dateTo: { getMonth: () => number; getFullYear: () => number } | null,
  prop: { value: { leaseAgreement: { fixedlong: boolean; infinite: boolean } } }
): boolean {
  if (!dateFrom || !dateTo) {
    return false;
  }

  const monthsDifference =
    dateTo.getMonth() - dateFrom.getMonth() + 12 * (dateTo.getFullYear() - dateFrom.getFullYear());

  // If availabilityTo is set, disable infinite contract
  if (dateTo) {
    prop.value.leaseAgreement.infinite = false;
  }

  // If less than 12 months, disable fixedlong
  if (monthsDifference < 12) {
    prop.value.leaseAgreement.fixedlong = false;
    return true;
  } else {
    return false;
  }
}

export function calculateMaxMonths(dateFrom: Date | null, dateTo: Date | null): number | undefined {
  if (!dateFrom || !dateTo) {
    return undefined;
  }

  const monthsDiff = Math.floor((dateTo.getTime() - dateFrom.getTime()) / (1000 * 60 * 60 * 24 * 30));

  return monthsDiff;
}
